import React from 'react'
import PropTypes from 'prop-types'

import styles from './TextPlate.scss'

const TextPlate = ({ children }) => {
    return <div className={styles.base}>{children}</div>
}
TextPlate.propTypes = {
    children: PropTypes.element,
}

export default TextPlate



// WEBPACK FOOTER //
// ./containers/Landing/components/LandingClans/components/TextPlate/TextPlate.jsx